import { EditLicensingOptionsMenuWebComponent } from './component/EditLicensingOptionsMenuWebComponent';
import { WEB_COMPONENT_EDIT_LICENSING_OPTIONS_MENU } from '../../../webcomponents.constants';

export { EditLicensingOptionsMenuWebComponent };

window.customElements.define(WEB_COMPONENT_EDIT_LICENSING_OPTIONS_MENU, EditLicensingOptionsMenuWebComponent);
